import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute('/')({
  /* mint-disable-next-line no-component-in-sync-route */
  component: Outlet,
  validateSearch: z.object({
    next: z.string().optional().catch(''),
  }),
  async beforeLoad({ context, location }) {
    const isAuthenticated = await context.isAuthenticated();
    if (!isAuthenticated) {
      throw redirect({
        to: '/login/',
        search: {
          next:
            'next' in location.search
              ? location.search.next?.toString()
              : location.pathname,
        },
      });
    } else if (isAuthenticated && location.pathname === '/') {
      throw redirect({
        to: '/taxonomy/metadata',
      });
    }
  },
});
